import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'

// Get RegulationCategory
export const ListRegulationCategory = createAsyncThunk(
  'regulation-category-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get('/api/regulation-category/list', params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create RegulationCategory
export const createRegulationCategory = createAsyncThunk(
  'regulation-category-create',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/regulation-category/store', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get RegulationCategory id
export const editRegulationCategory = createAsyncThunk(
  'regulation-category-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/regulation-category/edit/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete RegulationCategory
export const deleteRegulationCategory = createAsyncThunk(
  'regulation-category-delete',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/regulation-category/destroy/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get Regulation
export const ListRegulation = createAsyncThunk('regulation-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get('/api/regulation/list', params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create Regulation
export const createRegulation = createAsyncThunk(
  'regulation-create',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/regulation/store', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get Regulation id
export const editRegulation = createAsyncThunk('regulation-edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/regulation/edit/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Regulation view
export const viewRegulation = createAsyncThunk('regulation-view', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/regulation/view/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete Regulation
export const deleteRegulation = createAsyncThunk(
  'regulation-delete',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/regulation/destroy/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

type RegulationState = {
  record: any
  records: any
  errors: any
}

const initialState: RegulationState = {
  records: {
    data: [],
  },
  record: {},
  errors: '',
}

export const regulationSlice = createSlice({
  name: 'regulation',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ListRegulationCategory.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(editRegulationCategory.fulfilled, (state, action: PayloadAction<any>) => {
        state.record = action.payload
      })
      .addCase(ListRegulation.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(editRegulation.fulfilled, (state, action: PayloadAction<any>) => {
        state.record = action.payload
      })
  },
})

export const {reset} = regulationSlice.actions
export default regulationSlice.reducer
